import Presentation from "./presentation";

const Games = ( { gameList } ) => {
	return (
		<Presentation gameList = { gameList } />
	);
};

export default Games;